"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconRevert = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M56 14H20.24l3.43-3.43a3 3 0 1 0-4.24-4.24l-8.55 8.55a3 3 0 0 0-.38.46c0 .07-.08.15-.12.22a3 3 0 0 0-.16.3 3 3 0 0 0-.09.3c0 .09-.06.17-.08.26a3 3 0 0 0 0 1.17c0 .09.05.17.08.26a3 3 0 0 0 .09.3 3 3 0 0 0 .16.3c0 .07.07.15.12.22a3 3 0 0 0 .38.46l8.55 8.55a3 3 0 0 0 4.24-4.24L20.24 20H53v32H20.27V39.7a3 3 0 1 0-6 0V55a3 3 0 0 0 3 3H56a3 3 0 0 0 3-3V17a3 3 0 0 0-3-3z"
  })),
  height: undefined,
  width: undefined
});
IconRevert.displayName = 'IconRevert';
var _default = IconRevert;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/revert.js
// module id = 174
// module chunks = 0